<template>
    <div class="container-fluid">
        <ToastTemplet :bus="toast"></ToastTemplet>
        <div class="row mt-5">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">Banks</h3>

                <div class="card-tools">
                    <input class="btn search_box" type="text" placeholder="Search" @keyup="searchit" v-model="search" aria-label="Search">
                    <button class="btn btn-success" @click="newBank()">Add New</button>
                    <vue-excel-xlsx
                        :data="bank_mastersExcel"
                        :columns="columns"
                        :filename="'BankData'"
                        :sheetname="'sheetname'"
                        class="btn btn-success"
                        >
                        Excel
                    </vue-excel-xlsx>
                </div>
              </div>
              <!-- /.card-header -->
              <div class="card-body table-responsive p-0">
                        <table class="table table-hover">
                        <tr>
                            <th>NO</th>
                            <th>Bank Name</th>
                            <th>Bank Address</th>
                            <th>Modify</th>
                        </tr>
                        <tr v-for="(bank_master,i) in bank_masters.data" :key="bank_master.BANK_ID">
                            <td>{{ i+1 }}</td>
                            <td> {{ bank_master.Bank_Name}} </td>
                            <td>{{ bank_master.Bank_Address }}</td>
                            <td>
                                <a href="#" @click="editBank(bank_master)"><i class="fas fa-edit"></i></a>/
                                <a href="#" @click="deleteBank(bank_master.BANK_ID)"><i class="fas fa-trash-alt red"></i></a>
                            </td>
                        </tr>
                        </table>
                    </div>
                    <!-- /.card-body -->
                    <div class="card-footer">
                        <div class="row">
                            <div class="col-md-9">
                                    <pagination :data="bank_masters" @pagination-change-page="loadAndSearchBank" :limit="this.$PaginationCounterLimit">
                                    <span slot="prev-nav">&lt; Previous</span>
                                    <span slot="next-nav">Next &gt;</span>
                                </pagination>
                            </div>
                            <div class="col-md-1 show-text">
                                Show
                            </div>
                            <div class="col-md-1 pagination">
                                <multiselect
                                    v-model="$PaginationLimit"
                                    :options="this.$PaginationOptions"
                                    :allow-empty="false"
                                    open-direction="top"
                                    :show-labels="false"
                                    @input="loadAndSearchBank(1)"
                                    aria-required="true">
                                </multiselect>
                            </div>
                            <div class="col-md-1 entries-text">
                                Entries
                            </div>
                        </div>
                    </div>
                    </div>
                    <!-- /.card -->
                </div>
                </div><!-- /.row -->
                <!-- Modal -->
            <div class="modal fade" id="bank_model" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" v-show="!editmode" id="exampleModalLabel">Add New Bank</h5>
                    <h5 class="modal-title" v-show="editmode" id="exampleModalLabel">Update Bank</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <form @submit.prevent="editmode ? UpdateBank() : CreateBankMaster()" @keydown="form.onKeydown($event)">
                <div class="modal-body">
                        <div class="form-group">
                            <label>Bank Name</label>
                            <input v-model="form.Bank_Name" type="text" name="Bank_Name"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('Bank_Name') }">
                            <has-error :form="form" field="Bank_Name"></has-error>
                        </div>
                        <div class="form-group">
                            <label>Bank Address</label>
                            <input v-model="form.Bank_Address" type="text" name="Bank_Address"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('Bank_Address') }">
                            <has-error :form="form" field="Bank_Address"></has-error>
                        </div>
                </div>
                <div class="modal-footer">
                    <button type="submit" v-show="!editmode" class="btn btn-primary">Save Bank</button>
                    <button type="submit" v-show="editmode" class="btn btn-success">Update</button>
                </div>
                </form>
                </div>
            </div>
            </div>
            <!--end Model-->
    </div>
</template>

<script>
    import ToastTemplet from "../widget/toast";
    export default {
        components: { Multiselect,ToastTemplet },
        data(){
            return{
                toast: new Vue(),
                editmode:false,
                search:'',
                bank_masters:{},
                bank_mastersExcel:[],
                form: new Form({
                    BANK_ID:'',
                    Bank_Name:'',
                    Bank_Address:''
                }),
                columns : [
                    {
                        label: "Bank Name",
                        field: "Bank_Name",
                    },
                    {
                        label: "Bank Address",
                        field: "Bank_Address",
                    },
                    {
                        label: "Bank Is Active",
                        field: "Bank_Is_Active",
                    },
                ],
            }
        },
        created() {
            Fire.$on('searching',()=>{
                this.loadAndSearchBank();
            })
            Fire.$on('AfterChangeBank',()=>{
                this.loadAndSearchBank();
            });
        },
        mounted(){
            this.loadAndSearchBank();
        },
        methods:{
            searchit: _.debounce(()=>{
                Fire.$emit('searching');
            },500),
            UpdateBank(){
                this.toast.$emit("LoadingOn");
                this.form.put('bank/'+this.form.BANK_ID)

                .then(()=> {
                    Fire.$emit('AfterChangeBank');
                    $('#bank_model').modal('hide');
                    this.toast.$emit('LoadingOffSuccess', "Bank Updated successfully");
                })
                .catch(()=> {
                    this.toast.$emit('LoadingOffError', "your request could not be processed.");
                })
            },
            editBank(bank_master){
                this.editmode = true,
                this.form.reset();
                $('#bank_model').modal('show');
                this.form.fill(bank_master);
            },
            newBank(){
                this.editmode = false,
                this.form.reset();
                $('#bank_model').modal('show');
            },
            deleteBank(BANK_ID){
                Swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                    }).then((result) => {
                        if(result.value){
                            this.form.delete('bank/'+BANK_ID).then(()=>{
                            Fire.$emit('AfterChangeBank');
                            this.toast.$emit('SwalSuccess',"Deleted!", "Bank Deleted.");

                        }).catch(()=>{
                            this.toast.$emit('SwalWarning',"Failed!", "There was something wrong, Or Bank Is Already In Use");
                        })
                        }
                    })
            },
            CreateBankMaster(){
                this.toast.$emit("LoadingOn");
                this.form.post('bank')
                .then(()=>{
                    $('#bank_model').modal('hide')
                    // this.loadAndSearchBank();
                    Fire.$emit('AfterChangeBank');
                    this.toast.$emit('LoadingOffSuccess', "Bank Create successfully");

                })
                .catch(()=>{
                    this.toast.$emit('LoadingOffError', "your Request Failed.");
                })
            },
            loadAndSearchBank(page = 1) {
                this.toast.$emit('ProgressBarLoading');
                axios
                    .get("loadAndSearchBank?query=" + this.search +"&page=" + page + "&PaginationLimit="+ this.$PaginationLimit)
                    .then(({ data }) => {
                        this.bank_masters = data,
                        this.toast.$emit('ProgressBarFinish'),
                        this.loadAndSearchBankExcel()
                    })
                    .catch(() => {
                        this.toast.$emit('ProgressBarFailerror',"Cannot Find Any Such User");
                    });
            },
            loadAndSearchBankExcel(page = 1) {
                this.toast.$emit('ProgressBarLoading');
                axios
                    .get("loadAndSearchBankExcel?query=" + this.search +"&page=" + page + "&PaginationLimit="+ this.$PaginationLimit)
                    .then(({ data }) => {
                        this.bank_mastersExcel = data,
                        this.toast.$emit('ProgressBarFinish')
                    })
                    .catch(() => {
                        this.toast.$emit('ProgressBarFailerror',"Cannot Find Any Such User");
                    });
            },
        }
    }
</script>
